import React from "react";
import HairColorStreaksLandingMissionCard from "./HairColorStreaksLandingMissionCard";
import "./HairColorStreaksLandingMission.css"
const HairColorStreaksLandingMissionMain = () => {
  return (
    <div className="hairColorStreakLandingMissionMain">
      <HairColorStreaksLandingMissionCard />
      <HairColorStreaksLandingMissionCard />
      <HairColorStreaksLandingMissionCard />
      <HairColorStreaksLandingMissionCard />
    </div>
  );
};

export default HairColorStreaksLandingMissionMain;
